import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { map as o, result as a } from "./asyncUtils.js";
import r from "./Collection.js";
import t from "./Loadable.js";
import { isNone as l } from "./maybe.js";

function n(_x, _x2) {
  return _n.apply(this, arguments);
}

function _n() {
  _n = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(o, a) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return o.load();

          case 2:
            return _context.abrupt("return", i(o, a));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _n.apply(this, arguments);
}

function i(_x3, _x4) {
  return _i.apply(this, arguments);
}

function _i() {
  _i = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(n, i) {
    var f, c, e;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            f = [], c = function c() {
              for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
                o[_key] = arguments[_key];
              }

              for (var _i2 = 0, _o = o; _i2 < _o.length; _i2++) {
                var _a = _o[_i2];
                l(_a) || (Array.isArray(_a) ? c.apply(void 0, _toConsumableArray(_a)) : r.isCollection(_a) ? _a.forEach(function (o) {
                  return c(o);
                }) : t.isLoadable(_a) && f.push(_a));
              }
            };
            i(c);
            e = null;
            _context3.next = 5;
            return o(f, /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(o) {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.t1 = !1;
                        _context2.next = 3;
                        return a(s(o) ? o.loadAll() : o.load());

                      case 3:
                        _context2.t2 = _context2.sent.ok;
                        _context2.t0 = _context2.t1 !== _context2.t2;

                        if (_context2.t0) {
                          _context2.next = 7;
                          break;
                        }

                        _context2.t0 = e;

                      case 7:
                        _context2.t3 = _context2.t0;

                        if (_context2.t3) {
                          _context2.next = 10;
                          break;
                        }

                        e = o;

                      case 10:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x5) {
                return _ref.apply(this, arguments);
              };
            }());

          case 5:
            if (!e) {
              _context3.next = 7;
              break;
            }

            throw e.loadError;

          case 7:
            return _context3.abrupt("return", n);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _i.apply(this, arguments);
}

function s(o) {
  return "loadAll" in o && "function" == typeof o.loadAll;
}

export { n as default, n as loadAll, i as loadAllChildren };